import React from 'react';
import { Drawer, Form, Space, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useMutation } from 'hooks/apollo';
import useCustomer from 'hooks/useCustomer';
import { gql } from '@apollo/client';
import globalMessages from 'translations/messages';

import EditFunnel from './EditFunnel';
import messages from './messages';

const CREATE_FUNNEL = gql`
  mutation($input: JSON!) {
    createFunnel(input: $input) {
      id
    }
  }
`;

const CreateFunnelDrawer = ({ open, onClose, onDone }) => {
  const [form] = Form.useForm();
  const { customer } = useCustomer();
  const [createFunnelMutation, { loading }] = useMutation(CREATE_FUNNEL);

  const initialValues = {
    websiteId: null,
    steps: [{ title: 'Step 1', sortIndex: 0 }, { title: 'Step 2', sortIndex: 1 }],
  };

  const onSubmit = async (values) => {
    const { data } = await createFunnelMutation({
      variables: {
        input: {
          ...values,
          customerId: customer.id,
        },
      },
    });
    form.resetFields();
    onDone(data.createFunnel.id);
  };

  return (
    <Drawer
      open={open}
      placement="right"
      onClose={onClose}
      destroyOnClose
      width={400}
      title={<FormattedMessage {...messages.createFunnel} />}
      footer={(
        <Space>
          <Button
            onClick={onClose}
          >
            <FormattedMessage {...globalMessages.cancel} />
          </Button>
          <Button
            onClick={form.submit}
            type="primary"
            loading={loading}
          >
            <FormattedMessage {...globalMessages.save} />
          </Button>
        </Space>
        )}
    >
      <Form layout="vertical" form={form} initialValues={initialValues} onFinish={onSubmit}>
        <EditFunnel />
      </Form>
    </Drawer>
  );
};

export default CreateFunnelDrawer;
